import React from 'react';
import styled from 'styled-components';
import utilsService from '../../../servises/utils.service';

const FullBarStyled = styled.div`
  height: 8px;
  background-color: rgba(255, 255, 255, 0.08);
  margin: 6px 0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
    
  &.smaller{
    height: 5px;
  }
`;

const CurrentValueBarStyled = styled.div`
  height: 100%;
  max-width: 100%;
  border-radius: 4px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease;
`;

const BarWrapperStyled = styled.div`
  margin-bottom: 14px;
  legend {
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 4px;
  }
`;

const UnitsStyled = styled.div`
  font-size: 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.45);
  font-family: Consolas, monospace;

  .middle {
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
  }
`;

const FillBar = props => {
    const {
        name,
        nameOvveride,
        totalUnit = '%',
        currentUnit = '%',
        min = 0,
        total,
        current,
        originalCurrent,
        originalTotal,
        smaller
    } = props;

    let percent = 0;
    if (originalTotal) {
        percent = utilsService.getPercent(originalCurrent, originalTotal);
    } else {
        percent = utilsService.getPercent(current, total);
    }

    if (total === 0) {
        percent = 0;
    }

    const displayPercent = Number.isNaN(percent) ? 0 : percent;
    const barWidth = Math.min(100, Math.max(0, displayPercent));

    let barColor = 'linear-gradient(90deg, var(--color-info) 0%, var(--color-info-hover) 100%)';

    if (percent > 70) {
        barColor = 'linear-gradient(90deg, var(--color-warning) 0%, var(--color-warning-hover) 100%)';
    }

    if (percent > 90) {
        barColor = 'linear-gradient(90deg, var(--color-danger) 0%, var(--color-danger-hover) 100%)';
    }

    let classes = 'llddeeassdd';
    if(smaller) {
        classes = 'llddeeassdd smaller';
    }

    return (
        <BarWrapperStyled>
            {nameOvveride && (
                nameOvveride
            )}
            {name && !nameOvveride && (
                <legend className='color-2'>{ name }</legend>
            )}
            <FullBarStyled className={ classes }>
                <CurrentValueBarStyled
                    className={ 'llddeeassdd-s' }
                    style={ {
                        width: barWidth + '%',
                        background: barColor
                    } }/>
            </FullBarStyled>
            <UnitsStyled>
                <span className="start">
                    { `${ min }` }
                </span>
                <span className="middle">
                    { `${ current } ${ currentUnit }` }
                </span>
                <span className="end">
                    { `${ total } ${ totalUnit }` }
                </span>
            </UnitsStyled>
        </BarWrapperStyled>
    );
};

export default FillBar;
